<template>
    <div class="report__page">
        <h2>Report Details</h2>
        <ReportDetailsSelector 
            :details="customDetails"
            :is-compact="false"
        />
        <!-- ACTIVITY LOGS -->
    </div>
</template>

<script>
import ReportDetailsSelector from './ReportDetailsSelector.vue';

export default {
    components: {
        ReportDetailsSelector
    },

    data() {
        return {
            customDetails: [
                { value: 'site_name', label: 'Site' },
                { value: 'meta', label: 'ID' },
                { value: 'datetime', label: 'Date / Time' },
                { value: 'full_name', label: 'Full Name' },
                { value: 'company', label: 'Company' },
                { value: 'checked', label: 'Status' },
                { value: 'pass', label: 'Pass/Fail Status' },
                { value: 'notes', label: 'Notes' },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.report__page {
    height: 100%;
    padding: 0.5rem;

    h2 {
        padding-left: 1rem;
        margin: 0;
    }
}
</style>